import React, { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import LinearProgress from "@material-ui/core/LinearProgress";
import Box from "@material-ui/core/Box";

import MessageLogsGrid from "../Grid/MessageLogsGrid.jsx";
import FilterComponent from "../FilterComponent/FilterComponent.jsx";

const MessageLogs = (props) => {
    const versionFilter = "message_logs";

    const { mainId } = useParams();
    const location = useLocation();

    let resGrid = <Typography variant={"body1"}>Нет записей </Typography>;

    if (props.MessageLogsData.loading) {
        resGrid = <LinearProgress mt={4} />;
    } else if (
        !props.MessageLogsData.loading &&
        props.MessageLogsData?.AllItems?.length > 0
    ) {
        resGrid = (
            <MessageLogsGrid
                editAction={props.editAction}
                removeAction={props.removeAction}
                resData={props.MessageLogsData}
                columns={props.columns}
                fields={props.fields}
                paramsChangeHandler={props.paramsChangeHandler}
                getParams={cleanParams(
                    props.globalSearch.search[versionFilter],
                )}
                globalSearch={props.globalSearch}
                updateGlobalSearch={props.updateGlobalSearch}
                versionFilter={versionFilter}
                roomTypesShort={props.roomTypesShort}
                hotelId = {props.hotelId}
            />
        );
    }
    return (
        <Paper elevation={3}>
            <Box p={3}>
                <Typography mb={3} variant={"h5"}>
                    {props.title}
                </Typography>
            </Box>
            <FilterComponent
                pathname={location.pathname}
                initSearch={props.paramsChangeHandler}
                roomTypes={props.roomTypes}
                getParams={cleanParams(props.globalSearch.search.message_logs)}
                globalSearch={props.globalSearch}
                updateGlobalSearch={props.updateGlobalSearch}
            />
            <Box mt={4}>{resGrid}</Box>
        </Paper>
    );
};

MessageLogs.defaultProps = {
    MessageLogsData: {
        AllItems: [],
        AuxItems: [],
        currentItem: null,
        error: null,
    },
    columns: [
        { id: "id", label: "id"},
        { id: "message_type", label: "Тип сообщения"},
        { id: "status", label: "Статус"},
        { id: "full_name_guest", label: "ФИО гостя"},
        { id: "date_in", label: "Дата заезда"},
        { id: "date_out", label: "Дата выезда"},
        { id: "reservation_number", label: "Номер бронирования"},
        { id: "entity_id", label: "ИД входящего объекта"},
        { id: "user_id", label: "Отправитель"},
        { id: "created_at", label: "Время создания"},
        { id: "updated_at", label: "Время обновления"},
        { id: "interface_id", label: "Интерфейс"},
        { id: "request", label: "Текст запроса"},
        { id: "response", label: "Текст ответа"},
        { id: "remove_button", label: "Управление"},
    ],
};


export default MessageLogs;

const cleanParams = (obj) => {
    const newParams = {};
    for (const key in obj) {
        if (obj[key] !== "") {
            newParams[key] = obj[key];
        }
    }
    return newParams;
};
